module.exports = __webpack_public_path__ + "img/logo.3630aec9.png";